module.exports = __webpack_public_path__ + "img/ekyc_frame.cbacb8c9.svg";